import { useCallback, useEffect, useState } from 'react';
import { SubscriptionResponse } from 'shared/types/Subscription';

import { useUserContext } from '@/context/UserContext';
import Sentry from '@/services/sentry';
import { SubscriptionsAPI } from '@/services/subscriptions';

export const useSubscriptions = () => {
    const { userProfileData } = useUserContext();

    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [subscriptions, setSubscriptions] = useState<
        SubscriptionResponse[] | null
    >(null);

    const fetchSubscription = useCallback(async () => {
        try {
            setIsLoading(true);
            setError(null);

            const response = await SubscriptionsAPI.fetchSubscriptions();

            setSubscriptions(response.payload || []);
        } catch (err) {
            setError(err.message || 'Failed to fetch subscriptions');
            Sentry.recordError(err);
        } finally {
            setIsLoading(false);
        }
    }, [setIsLoading, setError, setSubscriptions]);

    useEffect(() => {
        if (userProfileData && subscriptions === null) {
            fetchSubscription();
        }

        if (!userProfileData) {
            setSubscriptions(null);
        }
    }, [userProfileData, fetchSubscription, subscriptions]);

    return {
        isLoading,
        error,
        subscriptions,
    };
};
